export const AUDIT_TRAIL_NEW = "NEW";
export const AUDIT_TRAIL_EDIT = "EDIT";
export const AUDIT_TRAIL_DELETE = "DELETE";

export const MODULE_PRODUCT_BRANDS = "MODULE_PRODUCT_BRANDS";
export const MODULE_PRODUCT_CATEGORIES = "MODULE_PRODUCT_CATEGORIES";
export const MODULE_PRODUCT = "MODULE_PRODUCT";
export const MODULE_PRODUCT_TAX = "MODULE_PRODUCT_TAX";

export const MODULE_CUSTOMER = "MODULE_CUSTOMER";
export const MODULE_MEMBERSHIP = "MODULE_MEMBERSHIP";

export const MODULE_EXPENSE = "MODULE_EXPENSE";
export const MODULE_EXPENSE_CATEGORY = "MODULE_EXPENSE_CATEGORY";

export const MODULE_REGISTRATION = "MODULE_REGISTRATION";
export const MODULE_EMPLOYEE = "MODULE_EMPLOYEE";
export const MODULE_VENDOR = "MODULE_VENDOR";
export const MODULE_PAYMENT_TYPE = "MODULE_PAYMENT_TYPE";
export const MODULE_TRANSACTION_TYPE = "MODULE_TRANSACTION_TYPE";
export const MODULE_CUSTOM_FIELD = "MODULE_CUSTOM_FIELD";

export const MODULE_STORE = "MODULE_STORE";
export const MODULE_STORE_LOCATION = "MODULE_STORE_LOCATION";
export const MODULE_CASH_REGISTER = "MODULE_CASH_REGISTER";
export const MODULE_CASH_REGISTER_CLOSING = "MODULE_CASH_REGISTER_CLOSING";
export const MODULE_PRINT_CONFIG = "MODULE_PRINT_CONFIG";

export const MODULE_SALES = "MODULE_SALES";
export const MODULE_ATTENDANCE = "MODULE_ATTENDANCE";

export const MODULE_INVENTORY = "MODULE_INVENTORY";
export const MODULE_PACKAGE = "MODULE_PACKAGE";
export const MODULE_EVENT = "MODULE_EVENT";

export const objToCSV = (obj) => {
  const csvRows = [];
  console.log("obj-->", obj);
  // ✅ Guard: empty or invalid data
  if (!Array.isArray(obj) || obj.length === 0) {
    return ""; // ya throw new Error("No data to export")
  }
  const headers = Object.keys(obj[0]);
  csvRows.push(headers.join(","));

  for (const row of obj) {
    const values = headers.map((header) => {
      const escaped = ("" + row[header]).replace(/"/g, '\\"');
      return `"${escaped}"`;
    });
    csvRows.push(values.join(","));
  }

  return csvRows.join("\n");
};

export const PRODUCT_TAG = "PRODUCT_TAG";
export const MODULE_TAG = "MODULE_TAG";
export const MODULE_OFFER = "MODULE_OFFER";
export const MODULE_PRODUCT_MODIFIER = "MODULE_PRODUCT_MODIFIER";

export const MODULE_ACCOUNTS = "MODULE_ACCOUNTS";

export const MODULE_ACCOUNT_MANAGEMENT = "MODULE_ACCOUNT_MANAGEMENT";

export const MODULE_BOM = "MODULE_BOM";
export const MODULE_COUPON = "MODULE_COUPON";

export const MODULE_LOYALTY_TYPE = "MODULE_LOYALTY_TYPE";
export const MODULE_LOYALTY_POINT_MAPPING = "MODULE_LOYALTY_POINT_MAPPING";

export const MODULE_SURVEY = "MODULE_SURVEY";
export const MODULE_SMS_TEMPLATE = "MODULE_SMS_TEMPLATE";
export const MODULE_CAMPAIGN = "MODULE_CAMPAIGN";
export const SALE_RETURN = "SALE_RETURN";
export const SALE_NEW = "SALE_NEW";
export const SALE_EDIT = "SALE_EDIT";

export const WORLDLINE_DEVICE = "WORLDLINE_DEVICE";
export const DEVICE_NONE = "DEVICE_NONE";
export const PINELABS_DEVICE = "PINELABS_DEVICE";
export const PAYU_DEVICE = "PAYU_DEVICE";
// export const API_URL = "https://backend-o3dyulj4pa-el.a.run.app/v1";
export const API_URL ="https://posibleapi-uat-789032243296.asia-south1.run.app/v1";
// export const API_URL ="http://localhost:4000/v1";

// "https://posibleapi-uat-789032243296.asia-south1.run.app/v1"
 // "http://localhost:4000/v1"; 
export const INVENTORY_URL="https://posible-inventory-engine-453510049042.asia-south1.run.app";